import styled from "styled-components";

export default styled.p`
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  color: rgb(70, 70, 70);
`;
